import styled from "styled-components";
import { EstablishmentBoxPropsInterface } from "./interfaces";
import colors from "../../assets/css/colors";



export const Container = styled.div<EstablishmentBoxPropsInterface>`
    margin-top: ${props => props.tooltip ? "0px" : "50px"};
    padding: 18px 18px 28px 20px;
    background-color: ${props => props.tooltip ? "#fff" : "#F6F5FA"};
    border-radius: 12px;
    width: 200px;
    box-shadow: ${props => props.tooltip 
        ? "0px 3px 13px -4px rgba(255, 202, 174, 0.815)" 
        : "none"};

    @media (max-width: 1200px) {
        width: 400px;
        margin: auto;
        margin-top: 50px;
    }

    @media (max-width: 500px) {
        width: 100%;
        margin-top: 25px;
    }
`;

export const Title = styled.h1`
    font: normal normal normal 14px Circular Std Book;
    color: #F58B1E;
    margin-bottom: 14px;
`;

export const InfoTitle = styled.h2`
    font: normal normal normal 10px Circular Std Book;
    color: #B8B4CC;
    margin-bottom: 5px;
`;

export const InfoData = styled.p`
    font: normal normal normal 10px/14px Circular Std Book;
    color: #454546;
    margin-bottom: 6px;
    word-wrap: break-word;
`;

export const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: 30px;
`;

export const ImageBackground = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 28px 11px;
    background-color: #FFFFFF;
    border-radius: 11px;
`;